import React from 'react';
import { useAuth } from '@/context/AuthContext';
import Layout from '@components/Layout';

import { myMemorialMenu, createMemorialMenu, memorialMenu } from '@utils/Index';

import header1 from '@images/landscape/dog.jpg';
import header2 from '@images/landscape/dog2.jpg';
import header3 from '@images/landscape/dog3.jpg';
import img1 from '@images/landscape/dog.jpg';
import img2 from '@images/landscape/dog2.jpg';

function Welcome() {
  const { globalUser, logout } = useAuth();

  return (
    <>
      {/* Middle Side Menu Bar */}
      <div className='col-lg-5'>
        <div className='card'>
          <h5 className='card-header bg-transparent border-bottom text-uppercase'>
            SmartDog Memorial
          </h5>
          <div className='card-body'>
            <p className='card-text'>
              Welcome to SmartDog Memorial, Your place to remember that special
              friend and tribute in their memory.
            </p>
            <p className='card-text'>
              Remembering the pet that has died and helping those affected by
              their death is at the heart of SmartDog. We offer individual
              tribute pages, to allow you to choose how to honour your loved pet
              in a way that feels right for you.
            </p>

            <h3 className='mb-3'>
              <small className='text-muted'>What is SmartDog Tribute</small>
            </h3>
            <p className='card-text'>
              This is your own special memorial in tribute to your loved pet,
              where you can share memories, thoughts and stories with family and
              friends as well as light candles, add music, photos and videos.
            </p>
            <p className='card-text'>
              You can run project's in their name, organise events, celebrate
              anniversaries – and much more.
            </p>
            <p className='card-text'>
              It’s simple, quick and free on every plan.
            </p>
          </div>
        </div>
      </div>
      {/* End Middle Side Menu Bar */}

      {/* Right Side Menu Bar */}
      <div className='col-lg-4'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='input-group'>
                <input
                  type='text'
                  className='form-control'
                  id='txtMemorialSearch'
                  placeholder='Search Memorials'
                />
                <button
                  className='btn btn-primary btn-xs'
                  id='btnMemorialSearch'
                  type='button'
                >
                  Search
                </button>
              </div>
            </div>
          </div>

          <a href="{% url 'when_a_dog_dies' %}">
            <div className='card'>
              <div className='row g-0 align-items-center'>
                <div className='col-md-4'>
                  <img
                    className='card-img img-fluid'
                    src={img1}
                    alt='Card image'
                  />
                </div>
                <div className='col-md-8'>
                  <div className='card-body'>
                    <h5 className='card-title'>When a pet dies...</h5>
                    <p className='card-text'>
                      Practical considerations when a pet passes away.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </a>

          <div className='card'>
            <div className='row g-0 align-items-center'>
              <div className='col-md-8'>
                <div className='card-body'>
                  <h5 className='card-title'>Grief Chat..</h5>
                  <p className='card-text'>
                    Speak to someone who cares and understands..
                  </p>
                </div>
              </div>
              <div className='col-md-4'>
                <img
                  className='card-img img-fluid'
                  src={img2}
                  alt='Card image'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Right Side Menu Bar */}
    </>
  );
}

export default Welcome;
